import axios from 'axios';
import { userManagerFactory } from '../services/oidc/utils/userManager';

const api = (apiUrl,amlJavaApi) => ({
  exec: ({ method, data, url }) => userManagerFactory().getUser().then((rez) => {
    const reqConfig = {
      method,
      url: `${url.includes('report/single/pdf') ? amlJavaApi:apiUrl}/${url}`,
      withCredentials: true,
      responseType: 'blob',
      headers: {
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${rez.access_token}`,
        OrganizationName: localStorage.getItem('orgName'),
        TimeZoneOffset: `${-(new Date().getTimezoneOffset()/60)}`,
        RequestIsComingFromAMLClientFrontend: " ",
      },
    };
    if (method.toLowerCase() === 'get') {
      reqConfig.params = data;
    } else {
      reqConfig.data = data;
    }

    return axios(reqConfig);
  }),
});
export default api;


// WEBPACK FOOTER //
// ./src/api-services/pdfApi.js